// Contrôle de vivacité (liveness) renforcé avec instructions aléatoires.
// Objectif : empêcher la « photo d'une photo » en demandant à l'utilisateur
// une action aléatoire et en vérifiant un mouvement réel via la caméra.

export const LIVENESS_INSTRUCTIONS = [
  { id: "left", label: "Tournez lentement la tête vers la GAUCHE" },
  { id: "right", label: "Tournez lentement la tête vers la DROITE" },
  { id: "blink", label: "Clignez des yeux plusieurs fois" },
  { id: "smile", label: "Souriez franchement à la caméra" },
  { id: "nod", label: "Hochez légèrement la tête (haut / bas)" },
];

export function pickInstruction() {
  return LIVENESS_INSTRUCTIONS[Math.floor(Math.random() * LIVENESS_INSTRUCTIONS.length)];
}

// Échantillonne plusieurs images pendant ~1,6 s et mesure le mouvement.
// Renvoie { ok, reason }.
export async function runLivenessChallenge(video, instructionId) {
  const W = 64, H = 64;
  const grabGray = () => {
    const t = document.createElement("canvas");
    t.width = W; t.height = H;
    const g = t.getContext("2d");
    g.drawImage(video, 0, 0, W, H);
    const d = g.getImageData(0, 0, W, H).data;
    const a = new Float32Array(W * H);
    for (let i = 0; i < W * H; i++) a[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
    return a;
  };
  const frames = [];
  for (let i = 0; i < 5; i++) {
    frames.push(grabGray());
    if (i < 4) await new Promise((r) => setTimeout(r, 320));
  }

  let motion = 0;
  for (let f = 1; f < frames.length; f++) {
    let m = 0;
    for (let i = 0; i < W * H; i++) m += Math.abs(frames[f][i] - frames[f - 1][i]);
    motion += m / (W * H);
  }
  motion /= frames.length - 1;

  if (motion < 1.0) {
    return { ok: false, reason: "Mouvement insuffisant. Bougez légèrement la tête puis reprenez (une photo figée est refusée)." };
  }
  return { ok: true };
}
